import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { PetitionerService } from 'src/app/services/petitioner.service';
import { select, Store } from '@ngrx/store';
import { getTaskRouteId } from 'src/app/modules/superTask/task-state/reducers/task.reducer';
import { VisaExtendedState } from '../l1-visa/utility/interfaces/visa-extended-state';
import { take} from 'rxjs/operators';
import { of } from 'rxjs';
import { E } from '@angular/cdk/keycodes';

@Injectable({ providedIn: 'root' })
export class SuperTaskSummaryResolver implements Resolve<any> {
  taskId: number;

  constructor(
    private petitionerService: PetitionerService,
    private store: Store<VisaExtendedState>,
  ) { }

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<any> | Promise<any> | any {    
    this.store.pipe(select(getTaskRouteId))
      .pipe(take(1))
      .subscribe((id: any) => {
        const taskIdStoredInSession = sessionStorage.getItem('taskId') || sessionStorage.getItem('taskID');        
        this.taskId = id > 0 ? id : (taskIdStoredInSession ? parseInt(taskIdStoredInSession) : 0);
      });
      if(this.taskId > 0){
        return this.petitionerService.getSuperTask(this.taskId);
      }else{
        return of(null);
      }
  }
}
